import Delimiter from "../../util/delimiter";
import MainNavBar from "./main_nav_bar";
import "./sub_nav_bar.css";
import logo_img from "../../img/main_logo.png";
import { Link } from "react-router-dom";

function SubNavBar() {
  return (
    <div className="sub_nav_bar">
      <div className="logo">
        <Link to="/">
          <img src={logo_img}></img>
        </Link>
      </div>
      <MainNavBar />
    </div>
  );
}

export default SubNavBar;
